import { Col, Row } from "../components/Grid/";
import Hero, { HeroText, HeroIcon } from "../components/Hero";
import ProductBar, { Tab } from "../components/ProductBar";

import ContentBlock from "../components/ContentBlock";
import DividerImage from "../components/DividerImage";
import HtmlContainer from "../components/HtmlContainer";
import Image from "../components/Image";
import OrderButton from "../components/OrderButton";
import PricingContainer from "../components/PricingContainer";
import PropTypes from "prop-types";
import React from "react";
import TextSection from "../components/TextSection";
import injectSheet from "react-jss";
import HeroImg from "../img/Hero-voter.jpg";
import FirstSectionLeftImage from "../img/Homepage-voter.png";
import FirstSectionMidImage from "../img/Letter-voter.png";
import FirstSectionRightImage from "../img/Segments-voter.png";
import ThirdSectionImage from "../img/Dataownership-voter.png";
import FourthSectionImage from "../img/Reliability-voter.png";
import FirstBackground from "../img/Background-voter-1.jpg";
import SecondBackground from "../img/Background-voter-2.jpg";
import ThirdBackground from "../img/Background-voter-3.jpg";
import FourthBackground from "../img/Background-voter-4.jpg";
import Video from "../components/Video";

const styles = theme => ({
  navcolour: {
    backgroundColor: theme.colours.products.voter
  },
  voterHeroIcon: {
    "@media (max-width: 823px)": {
      marginTop: "1rem"
    },
    marginTop: "5rem"
  },
  contentBox: {
    minHeight: "100vh"
  },
  contentSection: {
    maxWidth: "100vw",
    width: "100vw",
    "@media (max-width: 1800px)": {
      display: "none"
    }
  },
  contentSectionMobile: {
    "@media (min-width: 1800px)": {
      display: "none"
    }
  },
  mobileImage: {
    width: "325px",
    "@media (min-width: 1300px)": {
      display: "none"
    }
  },
  image: {
    width: "550px",
    "@media (max-width: 1300px)": {
      display: "none"
    }
  },
  contentSectionOne: {
    maxWidth: "100vw",
    width: "100vw",
    "@media (max-width: 1800px)": {
      display: "none"
    }
  },
  contentSectionOneMedium: {
    maxWidth: "100vw",
    width: "100vw",
    display: "none",
    "@media (min-width: 1300px) and (max-width: 1800px)": {
      display: "block"
    }
  },
  contentSectionOneMobile: {
    "@media (min-width: 1300px)": {
      display: "none"
    }
  },
  text: {
    textAlign: "justify",
    "@media (max-width: 823px)": {
      padding: 0,
      maxWidth: "80vw"
    },
    "& h1": {
      maxWidth: "60vw",
      fontSize: "5.4rem",
      textAlign: "center",
      "@media (max-width: 823px)": {
        fontSize: "2.8rem",
        width: "100%",
        maxWidth: "100%"
      }
    },
    "& h2": {
      fontSize: "2.2rem",
      textAlign: "center",
      fontWeight: 400
    },
    "& p": {
      "@media (min-width: 824px)": {
        width: "50vw",
        marginRight: 0
      }
    }
  },
  fourthSectionText: {
    maxWidth: "60vw",
    "@media (max-width: 823px)": {
      padding: 0,
      maxWidth: "80vw"
    },
    "& h1": {
      fontSize: "5.4rem",
      textAlign: "center",
      "@media (max-width: 823px)": {
        fontSize: "2.8rem",
        width: "100%",
        maxWidth: "100%"
      }
    },
    "& p": {
      "@media (min-width: 824px)": {
        maxWidth: "50vw",
        marginLeft: "100px",
        marginRight: 0
      }
    }
  },
  textColumns: {
    maxWidth: "30vw",
    paddingLeft: "10px",
    "@media (max-width: 823px)": {
      padding: 0,
      maxWidth: "80vw"
    },
    "& h1": {
      fontSize: "5.4rem",
      textAlign: "center",
      "@media (max-width: 823px)": {
        fontSize: "2.8rem",
        width: "100%"
      }
    },
    "& h2": {
      fontSize: "2.2rem",
      textAlign: "center",
      fontWeight: 400
    }
  },
  pricingContainer: {
    width: "100%"
  },
  pricing: {
    width: "35vw",
    "@media (max-width: 823px)": {
      padding: 0,
      width: "90%"
    },
    "& h1": {
      fontSize: "5.4rem",
      fontWeight: 400,
      margin: 0,
      textAlign: "center",
      "@media (max-width: 823px)": {
        fontSize: "2.8rem"
      }
    }
  },
  video: {
    // iPad portrait mode
    "@media (min-width: 824px) and (max-width: 1400px)": {
      width: "400px",
      height: "225px"
    }
  },
  videoContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%"
  }
});

const NavTabs = [
  {
    tabLink: "#features",
    tabName: "Features"
  },
  {
    tabLink: "#pricing",
    tabName: "Pricing"
  },
  {
    tabLink: "/contact",
    tabName: "Support"
  }
];

const VoterPage = ({ classes, data }) => (
  <div>
    <ProductBar
      className={classes.navcolour}
      logoLink="/voter"
      logoSrc="/voter-logo.svg"
    >
      {NavTabs.map(tab => (
        <Tab key={tab.tabName} tabLink={tab.tabLink} tabName={tab.tabName} />
      ))}
    </ProductBar>
    <Hero hero={HeroImg} withBar>
      <Row top center>
        <HeroText>
          <HeroIcon src="/voter-icon.png" className={classes.voterHeroIcon} />
          <HtmlContainer content={data.HeroText.html} />
        </HeroText>
      </Row>
    </Hero>
    <ContentBlock className={classes.contentBox} id="features">
      <div className={classes.contentSectionOne}>
        <Row center>
          <TextSection className={classes.text}>
            <HtmlContainer content={data.FirstContentSection.html} />
          </TextSection>
        </Row>
        <br />
        <br />
        <Row middle around>
          <Image image={FirstSectionLeftImage} className={classes.image} />
          <div className={classes.videoContainer}>
            <Video
              name="Caseworker.gov Video"
              className={classes.video}
              width="100%"
              height="150%"
              src="//www.youtube.com/embed/G6lXdrwwAIg?rel=0&amp;showinfo=0"
            />
          </div>
          <Image image={FirstSectionRightImage} className={classes.image} />
        </Row>
      </div>
      <div className={classes.contentSectionOneMedium}>
        <Row center>
          <TextSection className={classes.text}>
            <HtmlContainer content={data.FirstContentSection.html} />
          </TextSection>
        </Row>
        <br />
        <br />
        <Row middle center>
          <div className={classes.videoContainer}>
            <Video
              name="Caseworker.gov Video"
              className={classes.video}
              width="100%"
              height="150%"
              src="//www.youtube.com/embed/G6lXdrwwAIg?rel=0&amp;showinfo=0"
            />
          </div>
          <br />
          <br />
        </Row>
        <br />
        <br />
        <Row middle around>
          <Image image={FirstSectionLeftImage} className={classes.image} />
          <Image image={FirstSectionRightImage} className={classes.image} />
        </Row>
      </div>
      <div className={classes.contentSectionOneMobile}>
        <Col middle center>
          <TextSection className={classes.text}>
            <HtmlContainer content={data.FirstContentSection.html} />
          </TextSection>
          <br />
          <div className={classes.videoContainer}>
            <Video
              name="Caseworker.gov Video"
              className={classes.video}
              width="100%"
              height="150%"
              src="//www.youtube.com/embed/G6lXdrwwAIg?rel=0&amp;showinfo=0"
            />
          </div>
          <br />
          <br />
          <br />
          <Image image={FirstSectionMidImage} className={classes.mobileImage} />
          <br />
          <Image
            image={FirstSectionRightImage}
            className={classes.mobileImage}
          />
        </Col>
      </div>
    </ContentBlock>
    <DividerImage image={FirstBackground} />
    <ContentBlock className={classes.contentBox}>
      <div className={classes.contentSection}>
        <Row center>
          <TextSection className={classes.text}>
            <HtmlContainer content={data.SecondContentTitle.html} />
          </TextSection>
        </Row>
        <Row around>
          <TextSection className={classes.textColumns}>
            <HtmlContainer content={data.SecondContentLeftSection.html} />
          </TextSection>
          <TextSection className={classes.textColumns}>
            <HtmlContainer content={data.SecondContentMidSection.html} />
          </TextSection>
          <TextSection className={classes.textColumns}>
            <HtmlContainer content={data.SecondContentRightSection.html} />
          </TextSection>
        </Row>
      </div>
      <div className={classes.contentSectionMobile}>
        <Col middle center>
          <TextSection className={classes.text}>
            <HtmlContainer content={data.SecondContentTitle.html} />
          </TextSection>
          <TextSection className={classes.text}>
            <HtmlContainer content={data.SecondContentLeftSection.html} />
          </TextSection>
          <TextSection className={classes.text}>
            <HtmlContainer content={data.SecondContentMidSection.html} />
          </TextSection>
          <TextSection className={classes.text}>
            <HtmlContainer content={data.SecondContentRightSection.html} />
          </TextSection>
        </Col>
      </div>
    </ContentBlock>
    <DividerImage image={SecondBackground} />
    <ContentBlock className={classes.contentBox}>
      <Col middle center>
        <TextSection className={classes.text}>
          <HtmlContainer content={data.ThirdContentSection.html} />
        </TextSection>
        <br />
        <Image image={ThirdSectionImage} className={classes.image} />
        <Image image={ThirdSectionImage} className={classes.mobileImage} />
      </Col>
    </ContentBlock>
    <DividerImage image={ThirdBackground} />
    <ContentBlock className={classes.contentBox}>
      <Col middle center>
        <TextSection className={classes.fourthSectionText}>
          <HtmlContainer content={data.FourthContentSection.html} />
        </TextSection>
        <br />
        <Image image={FourthSectionImage} className={classes.image} />
        <Image image={FourthSectionImage} className={classes.mobileImage} />
      </Col>
    </ContentBlock>
    <DividerImage image={FourthBackground} />
    <ContentBlock className={classes.contentBox} id="pricing">
      <div className={classes.pricing}>
        <Col middle center>
          <TextSection>
            <HtmlContainer content={data.PricingSection.html} />
          </TextSection>
        </Col>
        <PricingContainer>
          <HtmlContainer content={data.PricingChecklist.html} />
        </PricingContainer>
        <Col middle center>
          <OrderButton
            eventlabel="Clicked Voter buy button"
            mailinfo="mailto:sales@electedtechnologies.com?subject=Voter.ID Sales Enquiry"
            label="Order Voter.ID Now"
            phonenumber="02 6169 1019"
          />
        </Col>
      </div>
    </ContentBlock>
  </div>
);

VoterPage.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.object
};

export default injectSheet(styles)(VoterPage);

/* global graphql */
export const VoterQuery = graphql`
  query VoterQuery {
    HeroText: markdownRemark(frontmatter: { name: { eq: "Voter-HeroText" } }) {
      html
      frontmatter {
        name
      }
    }
    FirstContentSection: markdownRemark(
      frontmatter: { name: { eq: "Voter-FirstSection" } }
    ) {
      html
      frontmatter {
        name
      }
    }
    SecondContentTitle: markdownRemark(
      frontmatter: { name: { eq: "Voter-SecondSectionTitle" } }
    ) {
      html
      frontmatter {
        name
      }
    }
    SecondContentLeftSection: markdownRemark(
      frontmatter: { name: { eq: "Voter-SecondSectionLeft" } }
    ) {
      html
      frontmatter {
        name
      }
    }
    SecondContentMidSection: markdownRemark(
      frontmatter: { name: { eq: "Voter-SecondSectionMid" } }
    ) {
      html
      frontmatter {
        name
      }
    }
    SecondContentRightSection: markdownRemark(
      frontmatter: { name: { eq: "Voter-SecondSectionRight" } }
    ) {
      html
      frontmatter {
        name
      }
    }
    ThirdContentSection: markdownRemark(
      frontmatter: { name: { eq: "Voter-ThirdSection" } }
    ) {
      html
      frontmatter {
        name
      }
    }
    FourthContentSection: markdownRemark(
      frontmatter: { name: { eq: "Voter-FourthSection" } }
    ) {
      html
      frontmatter {
        name
      }
    }
    PricingSection: markdownRemark(
      frontmatter: { name: { eq: "Voter-PricingParagraph" } }
    ) {
      html
      frontmatter {
        name
      }
    }
    PricingChecklist: markdownRemark(
      frontmatter: { name: { eq: "Voter-PricingColumn" } }
    ) {
      html
      frontmatter {
        name
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/voter.jsx